module.exports = __webpack_public_path__ + "static/media/icon-dash-documents.5bd998cb.png";